module.exports = __webpack_public_path__ + "img/logo.53dc55c8.png";